import { SecondaryText } from '@square/dashboard-protos/models/squareup/bbfrontend/common/debit_card/debit_card';
import assert from '@banking/ui/utils/assert';
import { Uint8ToString } from '@banking/ui/utils/uint8-to-string';
export const getBusinessName = cardRenderingDescription => {
  const {
    businessName
  } = cardRenderingDescription;
  return businessName;
};
export const getCustomizationImageDataURL = cardRenderingDescription => {
  const {
    cardCustomization
  } = cardRenderingDescription;
  if (cardCustomization == null) {
    return '';
  }
  const {
    mimeType,
    signatureImageBytes
  } = cardCustomization;
  if (mimeType.length === 0 || signatureImageBytes.length === 0) {
    return '';
  }
  return `data:${mimeType};base64,${Uint8ToString(signatureImageBytes)}`;
};
const debitCardClickEvent = {
  name: 'Click Checking Overview',
  properties: {
    action: 'Click',
    applet: 'Banking',
    page: 'Checking Overview',
    target: 'Debit Card'
  }
};
export const createDebitCardsListItemsFromCards = (cards, onActivatableCardClick, onCardInvitationClick, onCardClick, eventsService) => {
  return cards.map(card => {
    const {
      cardInvite,
      orderedCard
    } = card;
    if (cardInvite) {
      const {
        inviteToken,
        cardListElement,
        cardName,
        secondaryText,
        titleTrailingAccessory
      } = cardInvite;
      assert(cardListElement != null, 'card list element is null/undefined');
      assert(secondaryText != null, 'secondary text is null/undefined');
      return {
        businessName: getBusinessName(cardListElement),
        cardName,
        customizationImageDataURL: getCustomizationImageDataURL(cardListElement),
        subtext: secondaryText.text,
        subtextType: SecondaryText.SecondaryTextStyle.STANDARD,
        onClick: () => onCardInvitationClick(inviteToken),
        titlePill: titleTrailingAccessory?.pill
      };
    } else if (orderedCard) {
      const {
        cardListElement,
        cardName,
        secondaryText,
        isActivatable,
        cardToken,
        titleTrailingAccessory
      } = orderedCard;
      assert(cardListElement != null, 'card list element is null/undefined');
      assert(secondaryText != null, 'secondary text is null/undefined');
      return {
        businessName: getBusinessName(cardListElement),
        cardName,
        customizationImageDataURL: getCustomizationImageDataURL(cardListElement),
        subtext: secondaryText.text,
        subtextType: secondaryText.textStyle,
        onClick: () => {
          eventsService.track({
            kind: 'CDP',
            event: debitCardClickEvent
          });
          isActivatable ? onActivatableCardClick(cardToken) : onCardClick(cardToken);
        },
        titlePill: titleTrailingAccessory?.pill
      };
    } else {
      throw new Error('Missing cardInvite/orderCard from card');
    }
  });
};